import { EventEmitter, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { GDAuthInterface } from '../../../model/gd-auth';
import {
  RequestRecordTimeBarcodeGdDto,
  RequestRecordTimeBarcodeSF6Dto,
  RequestRecordTimeGdDto,
  RequestRecordTimeSF6Dto,
  ResponseDataRecordTimeSF6Dto,
  ResponseRecordTimeDto,
  ResponseGetButtonBreakTime,
  FuncAuthAttendance,
  ResponseNewTodayAttendance,
  AttendanceRedirectPage,
  ResponseTodayShift
} from '../../../shared/nestjs/gd-only/dto/attendance.dto';
import { AttendanceApi } from '../../../shared/nestjs/gd-only/services/attendance.api';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import {
  SettingServiceApi,
  SFAttendanceApi,
  SFAttendanceSF6Api,
  SFAttUploadSF6Api,
  WorkLocationApi
} from '../../../shared/sdk';
import { AppPreferences, Preference } from '../../../shared/local/app-preferences.local';
import { LoadingController, Platform, ToastController, ModalController, Events } from 'ionic-angular';
import { RequestSendtToAWSDto } from '../../feature/home/home.dto';
import { AppVersion } from '@ionic-native/app-version';
import { GDStorageInterface, StoredPrelogin } from '../../../model/gd-storage';
import { SFGOAuthService } from '../../../providers/sfgoauth.service/sfgoauth.service';
import { AnalyticsProvider } from '../../../providers/analytics/analytics';
import { HttpClient } from '@angular/common/http';
import { FileUploaderProvider, OptionsUploadWithHttp } from '../../../providers/file-uploader/file-uploader';
import { GlobalServiceProvider } from '../../../providers/global-service/global-service';
import { PermissionCheckProvider } from '../../../providers/permission-check/permission-check';
import { Diagnostic } from '@ionic-native/diagnostic';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { TranslateService } from '@ngx-translate/core';
import { StoragePathProvider } from '../../../providers/storage-path/storage-path';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import moment from 'moment';
import { AlertServiceProvider } from '../../../providers/alert-service/alert-service';
import { Storage } from '@ionic/storage';
import { AttWorkLocationApi } from '../../../shared/nestjs/gd-only/services/att-work-location.api';
import { SettingApi } from '../../../shared/nestjs/gd-all-in-one/services/setting.api';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Entry, File } from '@ionic-native/file';
import { ToastServiceProvider } from '../../../providers/toast-service/toast.service';
import { Messages } from '../../../helpers/messages';
import { AttendanceSettingService } from '../../../model/attendance/attendance-setting-service';
import { TrackerApi } from '../../../shared/nestjs/gd-only/services/tracker.api';
import { BackgroundGeolocationBloc } from '../../feature/background-geolocation/background-geolocation.bloc';
import { BackgroundGeolocationNative } from '../../../native/background-geolocation.native';
import { GeolocationNative } from '../../../native/geolocation.native';
import { GDIGeolocationCamera, GDNativeResponse, GreatdayPluginNative } from '../../../native/greatday-plugin.native';
import { StatusBar } from '@ionic-native/status-bar';
import { ResponseData, NestResponsesProvider } from '../../../shared/nestjs/nest-responses';
import { ResponseCovid19Zone, RequestAttendanceTempDto } from '../../../shared/nestjs/gd-only/dto/attendances.dto';
import { AttendancesApi } from '../../../shared/nestjs/gd-only/services/attendances.api';
import { ResponseAttendanceMachine, AttendancePreviewData } from '../../../model/attendance/attendance-preview.model';
import { TrackerBloc } from '../../feature/tracker/tracker.bloc';
import { ResponseCameraSetting, ResponseWebcam } from '../../../model/camera.model';
import { CameraNative } from '../../../native/camera.native';
import { Subject } from 'rxjs';
import { MyLocation } from '@ionic-native/google-maps';
import { EventLabel } from '../../../helpers/event-label';
import { ResponseGreatdayMapsPage } from '../../../model/greatday-maps.model';
import { CameraProvider } from '../../../providers/camera/camera.provider';
import { FaceSpoofingNative } from '../../../native/facespoofing.native';
import { PlatformServiceProvider } from '../../../providers/platform/platform-service';
import { EventNameAnalytics } from '../../../helpers/event-name-analytics';
import { BasePhotoApi } from '../../../shared/nestjs/gd-all-in-one/services/base-photo.api';
import { WorklocationServiceProvider } from '../../../providers/worklocation/worklocation.service';

declare var IRoot;
declare var mockchecker: any;
declare var autostartmanager;
declare const greatdayplugin;
declare const SecurityCheck;
declare const google;

@Injectable()
export class AttendanceBloc {
  public progressText = new EventEmitter<any>();
  public clockIn: any = null;
  public clockOut: any = null;
  public actualClockIn: any = null;
  public actualClockOut: any = null;
  private _feedBack: any;

  // Parameters for attendance
  public params = {
    setting: {
      attendanceLock: false, // regulating attendance may be outside the specified area or not
      cameraLock: true, // setting may skip camera or not
      checkRoot: false, // setting when record attendance , check root (fake gps) or not
      webAbsent: true, // setting for user to record from web or not
      showPosting: false, // setting for enabled or disabled posting
      checkFakeGPS: false, // setting for enabled or disabled posting
      checkAutoTime: true, // setting for enabled or disabled check automatic datetime
      offlineMode: true, // setting for check access page offline mode
      showEmpNo: true,
      takePhoto: true,
      attendanceFace: false,
      attendanceLockPrompt: false, // force and show alert if user outside coverage area,
      attendanceAddress: false,
      skipErrorLocation: false,
      developerOptions: true,
      allowRoot: false,
      attendanceFaceLiveness: false,
      attendanceFaceBlock: false,
      attendanceFaceLivenessAttempt: 3,
      attendanceFaceLivenessTreshold: 50,
      wlc: false
    },
    allowRoot: true, // allow root = check root ,check setting root, if false then check mock app in mobile device
    webAbsent: true, // setting access for attendance in website
    isCamera: true, // true if attendance is use camera (default use)
    isBarcode: false, // true if attendance is use barcode
    statusPicture: true, // status return from camera
    data: null, // data
    barcodeData: null, // data barcode result from plugin
    imageData: null, // data image or path the image
    imageBase64: null, // data imagebase64
    geolocation: null, // geolocation (user current location)
    flagButton: '', // setting attendance for record with camera (1) or not (0) default is use camera (1),
    skipErrorLocation: false
  };

  private SFGoAuth: GDAuthInterface;
  private storedPrelogin: StoredPrelogin;
  private SFGoStorage: GDStorageInterface;
  private myDate: any;
  private isSF6: boolean;
  private showBreakTime: boolean = false;
  private _funcAuthAttendance: FuncAuthAttendance = {
    showAE: false,
    showAC: false,
    showLeave: false,
    showShift: false,
    showOvt: false,
    showAL: false,
    showATTV: false,
    showOffline: false,
    showBarcode: false,
    showBST: false,
    showMassLeave: false,
    showHelp: false,
    showABP: false,
  }

  private _todayAttendance: ResponseNewTodayAttendance = {
    today: {
      actualIn: null,
      actualOut: null,
      starttime: null,
      endtime: null,
    },
    yesterday: {
      starttime: null,
      endtime: null,
      actualIn: null,
      actualOut: null,
    }
  };

  private _todayShift: ResponseTodayShift = {
    newshiftname: null,
    newshiftcode: null,
    newshiftstart: null,
    newshiftend: null,
    shiftBreak: []
  };

  private _loadingGetTodayAttendance: boolean = false;
  private _isRunRecordTime: boolean = false;
  private cameraSetting: ResponseCameraSetting = {
    attendance: 'default',
    activityRecording: 'default'
  }

  private tempAttendanceSetting: AttendanceSettingService;
  public languageCode = {
    en: "en", // english
    id: "in", // indonesia
    jp: "ja", // jepang
    th: "th", // thailand
    cn: "zh", // china
    kr: "ko", // korea
    my: "ms" // malaysia
  }

  public greatDayMapsPageListener$ = new Subject<MyLocation>();
  public greatDayMapsPageOpener$ = new Subject<MyLocation>();

  constructor(
    public nestApiProvider: NestApiProvider,
    private attendanceApi: AttendanceApi,
    private attendancesApi: AttendancesApi,
    private sfattuploadsf6Api: SFAttUploadSF6Api,
    private sfattendanceApi: SFAttendanceApi,
    private appPreferences: AppPreferences,
    private platform: Platform,
    private platformServiceProvider: PlatformServiceProvider,
    private appVersion: AppVersion,
    private sfgoAuthService: SFGOAuthService,
    private analyticsProvider: AnalyticsProvider,
    private http: HttpClient,
    private fileUploaderProvider: FileUploaderProvider,
    private globalServiceProvider: GlobalServiceProvider,
    private permissionCheckProvider: PermissionCheckProvider,
    private diagnostic: Diagnostic,
    private barcodeScanner: BarcodeScanner,
    private translate: TranslateService,
    private storagePathProvider: StoragePathProvider,
    private transfer: FileTransfer,
    private sfattendancesf6Api: SFAttendanceSF6Api,
    private workLocationApi: WorkLocationApi,
    private alertService: AlertServiceProvider,
    private storage: Storage,
    private attWorkLocationApi: AttWorkLocationApi,
    private settingApi: SettingApi,
    private camera: Camera,
    private file: File,
    private toastService: ToastServiceProvider,
    private settingServiceApi: SettingServiceApi,
    private loadingCtrl: LoadingController,
    private trackerApi: TrackerApi,
    private backgroundGeolocationBloc: BackgroundGeolocationBloc,
    private backgroundGeolocationNative: BackgroundGeolocationNative,
    private geolocationNative: GeolocationNative,
    private toastCtrl: ToastController,
    private greatdayPluginNative: GreatdayPluginNative,
    private statusBar: StatusBar,
    private modalCtrl: ModalController,
    private nestResponse: NestResponsesProvider,
    private trackerBloc: TrackerBloc,
    private cameraNative: CameraNative,
    private events: Events,
    private cameraProvider: CameraProvider,
    private faceSpoofingNative: FaceSpoofingNative,
    private basePhotoApi: BasePhotoApi,
    private worklocationService: WorklocationServiceProvider
  ) {

  }

  /**
   * SEND DATA ATTENDANCE TO API
   * @param auth
   * @param payloadGD
   * @param payloadSF6
   */
  recordTime(auth: GDAuthInterface, payloadGD: RequestRecordTimeGdDto, payloadSF6: RequestRecordTimeSF6Dto) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = null;
        if (auth.isSF6) {
          if (payloadSF6.attBreak) {
            /** record break time */
            result = await this.recordBreakTimeSF6(payloadSF6);
          } else {
            /** record attendance normal */
            result = await this.recordTimeSF6(payloadSF6);
          }
          resolve(result)
        } else {
          if (payloadGD.attBreak) {
            /** record break time */
            result = await this.recordBreakTimeGD(payloadGD);
          } else {
            /** record attendance normal */
            result = await this.recordTimeGD(payloadGD);
          }
          resolve(result)
        }

        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_RECORD_SUCCESS, result);
      } catch (error) {
        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_RECORD_FAILED, error);
        await this.appPreferences.setErrorMessage(error);
        reject(error)
      }
    })
  }

  /**
   * RECORD ATTENDANCE BARCODE
   * @param auth
   * @param payloadGD
   * @param payloadSF6
   */
  recordTimeBarcode(auth: GDAuthInterface, payloadGD: RequestRecordTimeBarcodeGdDto, payloadSF6: RequestRecordTimeBarcodeSF6Dto) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = null;
        if (auth.isSF6) {
          result = await this.recordTimeBarcodeSF6(payloadSF6);
        } else {
          if (payloadGD.attBreak) {
            result = await this.recordTimeQrCodeBreakGD(payloadGD);
          } else {
            result = await this.recordTimeBarcodeGD(payloadGD);
          }
        }

        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_BARCODE_RECORD_SUCCESS, result);
        resolve(result);
      } catch (error) {
        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_BARCODE_RECORD_FAILED, error);
        reject(error)
      }
    })
  }

  recordTimeGD(payload: RequestRecordTimeGdDto) {
    return new Promise<ResponseRecordTimeDto>((resolve, reject) => {
      this.attendanceApi.recordTime(payload).subscribe(
        result => {
          resolve(result)
        },
        error => {
          reject(error)
        }
      );
    })
  }

  recordTimeSF6(payloadSF6: RequestRecordTimeSF6Dto) {
    return new Promise((resolve, reject) => {
      this.attendanceApi.recordTimeSF6(payloadSF6)
        .pipe(map(response => response.data))
        .subscribe(
          result => {
            resolve(result);
          }
          , error => {
            reject(error)
          }
        );
    })
  }

  recordTimeBarcodeGD(payload: RequestRecordTimeBarcodeGdDto) {
    return new Promise((resolve, reject) => {
      this.attendanceApi.recordTimeQRCodeGD(payload)
        .map(res => res.data)
        .subscribe(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        )
    })
  }

  recordTimeBarcodeSF6(payload: RequestRecordTimeBarcodeSF6Dto) {
    return new Promise<ResponseDataRecordTimeSF6Dto>((resolve, reject) => {
      this.attendanceApi.recordTimeQRCodeSF6(payload)
        .pipe(map(response => response.data))
        .subscribe(result => {
          resolve(result)
        }, error => {
          reject(error)
        })
    })
  }

  getBreakButton() {
    return new Promise<boolean>((resolve, reject) => {
      this.attendanceApi.getBreakButton()
        .map(response => response.data)
        .subscribe(
          result => {
            resolve(result)
          },
          error => {
            reject(error);
          }
        )
    })
  }

  getBreakButtonGD() {
    return new Promise<ResponseGetButtonBreakTime>((resolve, reject) => {
      this.attendancesApi.getBreakButton()
        .map(response => response.data)
        .subscribe(
          result => {
            resolve(result)
          },
          error => {
            reject(error);
          }
        )
    })
  }

  recordBreakTimeGD(payload: RequestRecordTimeGdDto) {
    return new Promise<any>((resolve, reject) => {
      this.attendancesApi.recordTimeBreak(payload)
        .subscribe(
          result => {
            resolve(result)
          },
          error => {
            reject(error);
          }
        )
    })
  }

  recordTimeQrCodeBreakGD(payload: RequestRecordTimeBarcodeGdDto) {
    return new Promise<any>((resolve, reject) => {
      this.attendancesApi.qrCodeTimeBreak(payload)
        .subscribe(
          result => {
            resolve(result)
          },
          error => {
            reject(error);
          }
        )
    })
  }

  recordBreakTimeSF6(payload: RequestRecordTimeSF6Dto) {
    return new Promise((resolve, reject) => {
      this.attendanceApi.addBreakToTemp(payload)
        .map(response => response.data)
        .subscribe(
          result => {
            resolve(result)
          },
          error => {
            reject(error);
          }
        )
    })
  }

  checkAuthWifi(ssid: string, bssid: string) {
    return new Promise((resolve, reject) => {
      this.attendanceApi.checkAuthWifi({
        ssid, bssid
      })
        .map(response => response.data)
        .subscribe(
          result => {
            resolve(result)
          },
          error => {
            reject(error);
          }
        )
    })
  }

  async sendRecordToAWS(data: any): Promise<any> {
    try {
      await this.platform.ready();
      this.SFGoStorage = await this.sfgoAuthService.getGDStorage();
      this.storedPrelogin = this.SFGoStorage.storedPrelogin;
      const appVersion = await this.appVersion.getVersionNumber();
      const appCode = await this.appVersion.getVersionCode();
      const request = await this.formatDataRecordTime(data.request) || {};
      const response = data.response || {};
      let responseString = JSON.stringify(response);
      const messageError = await this.appPreferences.getErrorMessage();

      if (messageError) {
        responseString = `${JSON.stringify(response)} | ${JSON.stringify(messageError)}`
      }

      const body: RequestSendtToAWSDto = {
        'token': this.SFGoAuth.id,
        'companyCode': this.SFGoAuth.companyCode,
        'empId': this.SFGoAuth.empId,
        'url': this.storedPrelogin.GOPATHNEW || this.storedPrelogin.GOPATH,
        'message': response.message || 'default',
        'request': JSON.stringify(request) || 'default',
        'response': responseString || 'default',
        'versionApp': appVersion,
        'versionCode': appCode,
      }

      data.request.photoUrl = this.platform.is('cordova') ? data.request.photoUrl : await this.globalServiceProvider.convertBase64toBlob(data.request.photoUrl)
      const options: OptionsUploadWithHttp = {
        nativeURI: data.request.photoUrl,
        eventsWebview: data.request.photoUrl,
        type: 'image',
        body: body,
        options: data.request.options
      }

      const awsUrl = this.attendanceApi.apiSendAttAWS();
      await this.fileUploaderProvider.uploadWithHttp(options, awsUrl);
    } catch (error) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_FAILED_SEND_AWS, error);
    }

    return true;
  }

  formatDataRecordTime(record: any) {
    return new Promise(async (resolve) => {
      this.SFGoAuth = await this.appPreferences.getAuth();
      if (this.SFGoAuth) {
        let temp: any = {};
        if (this.SFGoAuth.isSF6) {
          if (record.isbarcode) {
            temp = {
              barcode: record.barcode || null,
              compid: this.SFGoAuth.companyId || null,
              datetime: record.datetime || null,
              empid: this.SFGoAuth.empId || null,
              photo: record.photo || null,
              flagInputStatus: null,
              geolocation: record.geolocation || null,
              att_on: record.attOn || 'offline',
              message: record.message || 'There are not message',
              error: record.error || []
            }
          } else {
            temp = {
              companyId: this.SFGoAuth.companyId || null,
              photoUrl: record.photoUrl || null,
              geolocation: record.geolocation || null,
              attOn: record.attOn || 'offline',
              datetime: record.datetime || null,
              empid: this.SFGoAuth.empId || null,
              photo: record.photo || null,
              message: record.message || 'There are not message',
              error: record.error || []
            }
          }
        } else {
          if (record.isbarcode) {
            temp = {
              barcode: record.barcode.text || null,
              record: {
                photoUrl: record.photoUrl || null,
                geolocation: record.geolocation || null,
                attOn: record.attOn || 'offline',
                time: record.datetime || null,
                picture: record.photo || null,
                flagButton: '',
              },
              message: record.message || 'There are not message',
              error: record.error || []
            }
          } else {
            temp = {
              photoUrl: record.photoUrl || null,
              geolocation: record.geolocation || null,
              attOn: record.attOn || 'offline' || null,
              time: record.datetime || null,
              picture: record.photo || null,
              flagButton: {
                innow: true,
                outnow: true,
                inyesterday: false,
                outyesterday: false,
                intomorrow: false
              },
              message: record.message || 'There are not message',
              error: record.error || []
            }
          }
        }

        resolve(temp);
      } else {
        resolve(null);
      }
    })
  }

  /**
   * PROCESS NATIVE LIKE GET LOCATION & CAMERA ETC.
   */
  gopathNewExist(): Promise<boolean> {
    return new Promise(async (resolve) => {
      let SFGoStorage = await this.storage.get('SFGoStorage');
      let storedPrelogin = SFGoStorage ? JSON.parse(SFGoStorage).storedPrelogin : {};

      if (storedPrelogin.hasOwnProperty('GOPATHNEW')) {
        resolve(true);
      } else {
        resolve(false);
      }
    })
  }

  getTodayAttendance(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storage.get('SFGoAuth').then(async (hasil) => {
        this.SFGoAuth = JSON.parse(hasil);

        if (this.SFGoAuth.isSF6) {
          this.SFGoStorage = await this.sfgoAuthService.getGDStorage();
          this.storedPrelogin = this.SFGoStorage.storedPrelogin;

          if (this.storedPrelogin.hasOwnProperty('GOPATHNEW')) {
            this.attendanceApi.getTodayAttendanceSF6(this.SFGoAuth.empId, moment().toISOString()).subscribe((result: any) => {
              resolve(result.data);
            }, error => {
              reject(error);
            })
          } else {
            this.sfattendancesf6Api.getTodayAttendance(this.SFGoAuth.empId, this.SFGoAuth.companyId, moment().toISOString()).subscribe((result) => {
              resolve(result);
            }, error => {
              reject(error);
            });
          }
        } else {
          this.attendanceApi.getTodayAttendance(this.SFGoAuth.empId, moment().toISOString()).subscribe((result: any) => {
            resolve(result.data);
          }, error => {
            reject(error);
          })
        }
      });
    })
  }

  getTodayShift(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storage.get('SFGoAuth').then(async (hasil) => {
        this.SFGoAuth = JSON.parse(hasil);

        if (this.SFGoAuth.isSF6) {
          let SFGoStorage = await this.storage.get('SFGoStorage');
          let storedPrelogin = SFGoStorage ? JSON.parse(SFGoStorage).storedPrelogin : {};

          if (storedPrelogin.hasOwnProperty('GOPATHNEW')) {
            this.attendanceApi.getTodayShiftSF6(this.SFGoAuth.empId, moment().toISOString()).subscribe((result: any) => {
              resolve(result.data)
            }, error => {
              reject(error)
            })
          } else {
            this.sfattendancesf6Api.getTodayShift(this.SFGoAuth.empId, this.SFGoAuth.companyId, moment().toISOString()).subscribe((result: any) => {
              resolve(result)
            }, error => {
              reject(error)
            })
          }
        } else {
          this.attendanceApi.getTodayShift(this.SFGoAuth.empId, moment().toISOString()).subscribe((result: any) => {
            resolve(result.data);
          }, error => {
            reject(error);
          })
        }
      });
    })
  }

  resetDataParams() {
    // Define set to default define data
    this.params.isBarcode = false;
    this.params.data = '';
    this.params.flagButton = '';
    this.params.imageData = '';
    this.params.flagButton = '';
    this.params.geolocation = '';
    this.params.barcodeData = null;
    this.params.skipErrorLocation = false;
  }

  /**
   * Record attendance get location, photo etc.
   * @param isOnline
   */
  recordAttendance(isOnline: boolean = true): Promise<any> {
    return new Promise(async (resolve) => {
      let response: any;

      // Define set to default define data
      this.resetDataParams();

      // get Authorization
      this.SFGoAuth = await this.sfgoAuthService.getAuthorization();

      // get camera setting
      await this.getCameraSetting();

      // Get setting service attendance
      let GDAttendanceSetting = await this.getAttendanceSetting();
      this.params.setting = GDAttendanceSetting;

      // Get setting TSF Settings for take attendance with camera or not
      this.params.setting.takePhoto = (typeof this.params.setting.takePhoto != 'undefined') ? this.params.setting.takePhoto : true;
      const isGooglePlayServicesAvailable: boolean = this.globalServiceProvider.getIsGooglePlayServicesAvailable();
      const isGoogleMapsAvailable: boolean = this.globalServiceProvider.getIsGoogleMapsAvailable();

      if (this.platform.is('android')) {
        // Check Auto Time before take camera
        if (this.params.setting.checkAutoTime) {
          const autoDate = await this.checkAutomaticDateTime();
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_AUTO_TIME, autoDate);
          if (!autoDate) {
            resolve(false);
            return false;
          }
        }

        // Check developer options
        if (this.params.setting.developerOptions) {
          // Check mobile device developer options is enabled or not
          const developerOptions = await this.checkDeveloperOptions();
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_DEVELOPER_MODE, developerOptions);
          if (developerOptions) {
            const res = await this.alertService.createMola('Please disable Developer Options to be able to record attendance');
            if (res) {
              this.openDeveloperOptions();
            }
            resolve(false);
            return false;
          }
        }

        // Jika google playservice tidak ada && tidak ada apps google maps, attendance menggunakan fungsi record attendance ios
        // Jika params.setting.wlc = true record attendance menggunakan recordAttendanceWithOutMaps
        if (isGooglePlayServicesAvailable && isGoogleMapsAvailable && !this.params.setting.wlc) {
          response = await this.recordAttendanceAndroid(isOnline)
        } else {
          response = await this.recordAttendanceWithOutMaps(isOnline);
        }

        // Check Auto Time after take camera
        if (this.params.setting.checkAutoTime) {
          const autoDate = await this.checkAutomaticDateTime();
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_AUTO_TIME, autoDate);
          if (!autoDate) {
            resolve(false);
            return false;
          }
        }
      } else {
        // Jika params.setting.wlc = true record attendance menggunakan recordAttendanceWithOutMaps
        response = isOnline && !this.params.setting.wlc
          ? await this.recordAttendanceIOS()
          : await this.recordAttendanceWithOutMaps(isOnline);
      }

      resolve(response);
    });
  }

  recordAttendanceBarcode(flag_inputStatus: any, isSF6: any, myDate: any): Promise<any> {
    return new Promise(async (resolve) => {
      // Define set to default define data
      this.resetDataParams();

      this.isSF6 = isSF6;
      this.myDate = myDate;

      // get Authorization
      this.SFGoAuth = await this.sfgoAuthService.getAuthorization();

      // Get setting service attendance
      let GDAttendanceSetting = await this.getAttendanceSetting();
      this.params.setting = GDAttendanceSetting;

      this.barcodeScanner.scan().then((barcodeData) => {
        if (barcodeData.cancelled) {
          resolve(false);
        }

        if (!barcodeData.cancelled) {
          let geolocation: any = {};
          this.params.isBarcode = true;
          this.params.barcodeData = barcodeData;
          this.params.flagButton = flag_inputStatus;

          this.permissionCheckProvider.getGeolocation().then(async (position) => {
            if (position.coords.latitude && position.coords.longitude) {
              geolocation = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              };

              this.params.geolocation = geolocation;
              let picture;

              if (this.params.setting.takePhoto) {
                picture = await this.takePicture();
              } else {
                picture = await this.savePicture();
              }

              resolve(picture);
            } else {
              const msg = 'Error Getting Location';

              let confirm = null;
              if (this.params.setting.skipErrorLocation) {
                confirm = await this.alertService.confirmMola(msg, 'Skip', 'Try Again');
              } else {
                confirm = await this.alertService.confirmMola(msg, 'Cancel', 'Try Again');
              }

              if (confirm) {
                this.recordAttendanceBarcode(flag_inputStatus, isSF6, myDate).then((data) => {
                  resolve(data);
                });
              } else {
                if (this.params.setting.skipErrorLocation) {
                  let picture = await this.takePicture();
                  resolve(picture);
                } else {
                  resolve(false);
                }
              }
            }
          }).catch(async (error) => {
            if (error.code === 99) {
              const confirm = await this.alertService.createMola(error.message);
              if (confirm && error.code === 99) {
                if (this.platform.is('ios')) {
                  this.diagnostic.switchToSettings();
                } else {
                  this.diagnostic.switchToLocationSettings();
                }
              }
              resolve(false);
            } else {

              const msg = (error.message === 'Timeout expired') ? 'Error Getting Location' : error.message || '';
              let confirm = null;

              if (this.params.setting.skipErrorLocation) {
                confirm = await this.alertService.confirmMola(msg, 'Skip', 'Try Again');
              } else {
                confirm = await this.alertService.confirmMola(msg, 'Cancel', 'Try Again');
              }

              if (confirm) {
                this.recordAttendanceBarcode(flag_inputStatus, isSF6, myDate).then((data) => {
                  resolve(data);
                });
              } else {
                if (this.params.setting.skipErrorLocation) {
                  let picture = await this.takePicture();
                  resolve(picture);
                } else {
                  resolve(false);
                }
              }
            }
          })

        }

      }, () => {
      }).catch(() => {
      });
    });

  }

  recordAttendanceAndroid(isOnline: boolean = true): Promise<any> {
    return new Promise(async (resolve) => {
      let isMock = false;
      let packageMock = [];
      let whiteList = [];

      try {
        const deviceIsRoot = await this.deviceIsRoot();
        if (deviceIsRoot) {
          resolve(false);
          return false;
        }

        // check if user has indicated mock apps
        if (this.params.setting.checkFakeGPS) {
          let chekMock: any = {};
          if (this.platform.is('android')) {
            const storageWhiteList = await this.storage.get('whiteListPackage');
            whiteList = [];
            if (storageWhiteList != null) {
              for (let packageName of storageWhiteList.data) {
                whiteList.push(packageName.package)
              }
            }
            chekMock = await this.checkMock(whiteList);
          } else {
            chekMock.isMock = false;
          }

          if (chekMock.isMock) {
            isMock = chekMock.isMock;
            packageMock = chekMock.indicated;
            throw new Error(chekMock.messages);
          }
        }
      } catch (e) {
        if (isMock) {
          //  GA
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_ROOT_AND_MOCK_LOCATION, e.message)
          this.alertService.createMolaMock(e.message, packageMock).then((value) => {
            if (value) {
              resolve({ mockDetect: true, value: value });
            } else {
              resolve(false);
            }
          });
        } else {
          //  GA
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_ROOT_AND_MOCK_LOCATION, e.message)
          this.alertService.createMola(e.message).then(() => {
            resolve({ mockDetect: false });
          });
        }
        return false;
      }

      // Get geolocation & take picture
      let attNativeRecord: GDIGeolocationCamera = {
        camera: { base64Image: '', nativeURL: '' },
        geolocation: { latitude: 0, longtitude: 0 },
        cancelled: false
      };

      let SFGoStorage = await this.storage.get('SFGoStorage');
      let getAttWorkLocation = await this.storage.get('attWorkLocation');

      if (SFGoStorage != null) {
        // harcode syariah mandiri intranet or Offline attendance
        if (JSON.parse(SFGoStorage).storedPrelogin.IST.toLowerCase().includes('-intranet') || !isOnline) {
          try {
            const position = await this.getGeolocation(isOnline);
            if (this.params.setting.takePhoto || (this.params.setting.takePhoto && !isOnline)) {
              if (this.cameraSetting.attendance === 'webcam') {
                attNativeRecord = await this.openWebcam(attNativeRecord);
              } else if (this.cameraSetting.attendance === 'camera-device') {
                attNativeRecord = await this.getCameraDeviceAndroid(attNativeRecord);
              } else {
                attNativeRecord = await this.greatdayPluginNative.getGDCamera();
              }
            } else {
              const attNativeResponseDefault = new GDNativeResponse();
              attNativeRecord = attNativeResponseDefault.response;
            }

            attNativeRecord.geolocation.latitude = position.latitude;
            attNativeRecord.geolocation.longtitude = position.longitude;
            attNativeRecord.geolocation['longitude'] = position.longitude;
          } catch (error) {
            const message = error.message || 'Timeout expired';
            if (error.code === 99) {
              await this.alertService.createMola(message);

              if (this.platform.is('ios')) {
                this.diagnostic.switchToSettings();
              } else {
                this.diagnostic.switchToLocationSettings();
              }

              resolve(false);
            } else {
              attNativeRecord = await this.showAlertErrorLocation(message);
              if (!attNativeRecord) {
                resolve(false);
                return false;
              } else {
                this.params.skipErrorLocation = true;
              }
            }
          }
        } else {
          // Online attendance
          if (this.params.setting.takePhoto) {
            const newParams = JSON.parse(getAttWorkLocation);
            const allowMock = !this.params.setting.checkFakeGPS;
            const attendanceAddress = this.params.setting.attendanceAddress || false;

            if (this.cameraSetting.attendance === 'webcam') {
              attNativeRecord = await this.getGeolocationAndroid();

              if (!attNativeRecord.cancelled) {
                attNativeRecord = await this.openWebcam(attNativeRecord);
              }
            } else if (this.cameraSetting.attendance === 'camera-device') {
              attNativeRecord = await this.getGeolocationAndroid();

              if (!attNativeRecord.cancelled) {
                attNativeRecord = await this.getCameraDeviceAndroid(attNativeRecord);
              }
            } else {
              newParams.allowMock = allowMock;
              newParams.whiteList = whiteList;
              attNativeRecord = await this.greatdayPluginNative.getLocationRadiusCamera(JSON.stringify(newParams), attendanceAddress);
            }
          } else {
            attNativeRecord = await this.greatdayPluginNative.getGDGeolocation();
          }
        }
      } else {
        // Offline attendance when user not login yet or there is no gopath/gopathnew yet
        try {
          const position = await this.getGeolocation(isOnline);
          attNativeRecord = await this.greatdayPluginNative.getGDCamera();
          attNativeRecord.geolocation.latitude = position.latitude;
          attNativeRecord.geolocation.longtitude = position.longitude;
          attNativeRecord.geolocation['longitude'] = position.longitude;
        } catch (error) {
          const message = error.message || 'Timeout expired';
          if (error.code === 99) {
            await this.alertService.createMola(message);

            if (this.platform.is('ios')) {
              this.diagnostic.switchToSettings();
            } else {
              this.diagnostic.switchToLocationSettings();
            }

            resolve(false);
          } else {
            attNativeRecord = await this.showAlertErrorLocation(message);
            if (!attNativeRecord) {
              resolve(false);
              return false;
            } else {
              this.params.skipErrorLocation = true;
            }
          }
        }
      }

      // Get geolocation & camera is cancelled
      if (attNativeRecord.cancelled) {
        resolve(false);
        return false;
      }

      try {
        localStorage.setItem('geolocationCache', JSON.stringify({
          coords: {
            latitude: attNativeRecord.geolocation.latitude,
            longitude: attNativeRecord.geolocation.longtitude
          }
        }));
      } catch (error) { }

      this.params.statusPicture = attNativeRecord.camera.base64Image ? true : false;
      this.params.imageData = attNativeRecord.camera.nativeURL || '';
      this.params.imageBase64 = attNativeRecord.camera.base64Image || '';
      this.params.geolocation = attNativeRecord.geolocation;

      // Show alert mocklocation
      if (this.params.setting.checkFakeGPS) {
        if (attNativeRecord.geolocation && attNativeRecord.geolocation.mock) {
          let mock = await this.showAlertMocklocation(attNativeRecord.geolocation.mock);
          if (mock != true) {
            resolve(false);
            return false;
          }
        } else {
          let chekMock: any = {};
          if (this.platform.is('android')) {
            const storageWhiteList = await this.storage.get('whiteListPackage');
            whiteList = [];
            if (storageWhiteList != null) {
              for (let packageName of storageWhiteList.data) {
                whiteList.push(packageName.package)
              }
            }
            chekMock = await this.checkMock(whiteList);
          } else {
            chekMock.isMock = false;
          }

          if (chekMock.isMock) {
            let mock = await this.showAlertMocklocation(chekMock.isMock);
            if (mock != true) {
              resolve(false);
              return false;
            }
          }
        }
      }

      // Get setting attendance lock
      if (!this.params.skipErrorLocation) {
        let checkCover = await this.checkValidationCover(isOnline);
        if (checkCover != true) {
          resolve(false);
          return false;
        }
      }

      let savePicture = await this.savePicture();
      resolve(savePicture);
    })
  }

  async getGeolocation(isOnline: boolean) {
    const result = { latitude: 0, longitude: 0 }

    try {
      const position = await this.permissionCheckProvider.getGeolocation();
      if (position.coords.latitude && position.coords.longitude) {
        result.latitude = position.coords.latitude;
        result.longitude = position.coords.longitude;
        try {
          localStorage.setItem('geolocationCache', JSON.stringify(position));
        } catch (error) { }
      }
      return result;
    } catch (error) {
      if (isOnline) {
        throw error;
      } else {
        console.log('return result error get geolocation', error);
        return result;
      }
    }
  }

  recordAttendanceIOS(): Promise<any> {
    return new Promise(async (resolve) => {

      // Geolocation IOS
      const geolocation: { latitude: number, longitude: number } = { latitude: 0, longitude: 0 };
      let recordPicture: any;

      // Check root/jeilbreak
      const deviceIsRoot = await this.deviceIsRoot();
      if (deviceIsRoot) {
        resolve(false);
        return false;
      }

      try {
        this.events.publish(EventLabel.OPEN_MAPS_GREATDAY_PAGE, true);
        const position = await new Promise<ResponseGreatdayMapsPage>(resolve => {
          this.events.subscribe(EventLabel.RESPONSE_MAPS_GREATDAY_PAGE, (data: ResponseGreatdayMapsPage) => resolve(data));
        });

        // Get setting attendance lock
        let isCover: boolean;
        let isAttendanceLock = (typeof this.params.setting.attendanceLock != 'undefined') ? this.params.setting.attendanceLock : this.params.setting.attendanceLock;
        let isAttendanceLockPrompt = (typeof this.params.setting.attendanceLock != 'undefined') ? this.params.setting.attendanceLockPrompt : this.params.setting.attendanceLockPrompt;

        if (position.location) {
          if (position.location.latLng.lat && position.location.latLng.lng) {
            geolocation.latitude = position.location.latLng.lat;
            geolocation.longitude = position.location.latLng.lng;

            // Set parameters attendance
            this.params.geolocation = geolocation;

            // check geoFence
            if (isAttendanceLock || isAttendanceLockPrompt) {
              isCover = await this.checkGeoFenceIsCoverage(this.SFGoAuth.empId, geolocation.latitude, geolocation.longitude);
            } else {
              isCover = true;
            }

            recordPicture = await this.recordPicture(this.params.geolocation, isCover);
            resolve(recordPicture);
          } else {
            recordPicture = await this.recordPicture(false, true);
            resolve(recordPicture);
          }
        } else {
          resolve(false);
        }
      } catch (error) {
        const message = error.message || 'Timeout expired';
        if (error.code === 99) {
          await this.alertService.createMola(message);

          if (this.platform.is('ios')) {
            this.diagnostic.switchToSettings();
          } else {
            this.diagnostic.switchToLocationSettings();
          }

          resolve(false);
        } else {
          recordPicture = await this.recordPicture(false, true);
          resolve(recordPicture);
        }
      } finally {
        this.events.unsubscribe(EventLabel.RESPONSE_MAPS_GREATDAY_PAGE)
      }
    });
  }

  recordAttendanceWithOutMaps(isOnline: boolean): Promise<any> {
    return new Promise(async (resolve) => {

      // Geolocation IOS
      let geolocation: any = {};
      let recordPicture: any;

      // Check root/jeilbreak
      const deviceIsRoot = await this.deviceIsRoot();
      if (deviceIsRoot) {
        resolve(false);
        return false;
      }

      try {
        const position = await this.getGeolocation(isOnline);

        // Get setting attendance lock
        let isCover: boolean;
        let isAttendanceLock = (typeof this.params.setting.attendanceLock != 'undefined') ? this.params.setting.attendanceLock : this.params.setting.attendanceLock;
        let isAttendanceLockPrompt = (typeof this.params.setting.attendanceLock != 'undefined') ? this.params.setting.attendanceLockPrompt : this.params.setting.attendanceLockPrompt;

        geolocation = {
          latitude: position.latitude,
          longitude: position.longitude
        };

        // Set parameters attendance
        this.params.geolocation = geolocation;

        // check geoFence
        if (isAttendanceLock || isAttendanceLockPrompt) {
          isCover = await this.checkGeoFenceIsCoverage(this.SFGoAuth.empId, geolocation.latitude, geolocation.longitude);
        } else {
          isCover = true;
        }

        recordPicture = await this.recordPicture(this.params.geolocation, isCover);
        resolve(recordPicture);
      } catch (error) {
        const message = error.message || 'Timeout expired';
        if (error.code === 99) {
          await this.alertService.createMola(message);

          if (this.platform.is('ios')) {
            this.diagnostic.switchToSettings();
          } else {
            this.diagnostic.switchToLocationSettings();
          }

          resolve(false);
        } else {
          recordPicture = await this.recordPicture(false, true);
          resolve(recordPicture);
        }
      }
    });
  }


  async deviceIsRoot(): Promise<boolean> {
    try {
      let getGDCheckRoot = await this.storage.get('GDCheckRoot');
      let GDCheckRoot = (getGDCheckRoot) ? JSON.parse(getGDCheckRoot) : {};
      this.params.allowRoot = (typeof GDCheckRoot.allowRoot != 'undefined') ? GDCheckRoot.allowRoot : this.params.allowRoot;

      if (!this.params.setting.allowRoot) {
        const isRooted = await this.checkRoot();
        if (isRooted) {
          this.alertService.createMola(Messages.WARNING_ATTENDANCE_ROOT_JAILBREAK);
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_ROOT_AND_MOCK_LOCATION, 'Device Is Root');
          return true;
        }
      }

      return false;
    } catch (error) {
      return false;
    }
  }

  private showAlertErrorLocation(message: string, isIOS: boolean = false, isOnline?: boolean) {
    return new Promise<any>(async (resolve) => {
      const msg = (message == 'Timeout expired') ? 'Error Getting Location' : message;
      let confirm = null;

      if (this.params.setting.skipErrorLocation) {
        confirm = await this.alertService.confirmMola(msg, 'Skip', 'Try Again');
      } else {
        confirm = await this.alertService.confirmMola(msg, 'Cancel', 'Try Again');
      }

      if (confirm) {
        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_GET_LOCATION, 'Failed');
        const retryRecord = await this.recordAttendance(isOnline);
        resolve(retryRecord);
      } else {
        if (this.params.setting.skipErrorLocation) {
          let attNativeRecord = null;

          if (isIOS) {
            attNativeRecord = await this.recordPicture(true, true);
          } else {
            attNativeRecord = await this.greatdayPluginNative.getGDCamera();
          }

          this.params.skipErrorLocation = true;
          resolve(attNativeRecord)
        } else {
          resolve(false);
        }
      }
    })
  }

  recordPicture(geoPlugin: boolean, isCover: boolean): Promise<any> {
    return new Promise(async (resolve) => {
      let pictureData: any;
      if (geoPlugin == false) {
        const showAlertErrorLocation = await this.showAlertErrorLocation('Error Getting Location', true);
        resolve(showAlertErrorLocation);
      } else if (isCover == false) {
        let result = false;
        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_GET_LOCATION, 'Outside Attendance Area');
        if (this.params.setting && this.params.setting.attendanceLockPrompt && !this.params.setting.attendanceLock) {
          const confirm = await this.alertService.confirmMola(Messages.OUTSIDE_ATTENDANCE_AREA, 'Close', 'Next');
          result = confirm ? true : false;
          if (confirm && this.params.setting.takePhoto) {
            pictureData = await this.takePicture();
            result = pictureData;
          }
        } else {
          await this.alertService.createMola(Messages.OUTSIDE_ATTENDANCE_AREA);
        }

        resolve(result);
      } else {
        if (this.params.setting.takePhoto) {
          pictureData = await this.takePicture();
        } else {
          this.params.statusPicture = false;
          pictureData = await this.savePicture();
        }

        resolve(pictureData);
      }
    })
  }

  takePicture(): Promise<any> {
    return new Promise(async (resolve) => {
      let pictureData: any;
      if (this.platform.is('android')) {
        pictureData = await this.getCameraGreatdayPlugin();
      } else {
        pictureData = await this.getCameraDevice();
      }
      resolve(pictureData);
    })
  }

  getCameraGreatdayPlugin(): Promise<any> {
    return new Promise(async (resolve) => {
      let cameraPlugin: GDIGeolocationCamera = {
        camera: { base64Image: '', nativeURL: '' },
        geolocation: this.params.geolocation,
        cancelled: false
      };

      let pictureData: any;
      if (this.params.setting.takePhoto) {
        if (this.cameraSetting.attendance === 'webcam') {
          cameraPlugin = await this.openWebcam(cameraPlugin);
        } else {
          cameraPlugin = await this.greatdayPluginNative.getGDCamera();
        }
      }

      if (cameraPlugin.cancelled) {
        this.params.statusPicture = false;
        pictureData = await this.savePicture();
        resolve(pictureData);
      } else {
        this.params.statusPicture = true;
        this.params.imageData = cameraPlugin.camera.nativeURL || '';
        this.params.imageBase64 = cameraPlugin.camera.base64Image || '';
        pictureData = await this.savePicture();
        resolve(pictureData)
      }
    })
  }

  getCameraDeviceAndroid(attNativeRecord?: GDIGeolocationCamera): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const options: CameraOptions = {
          quality: 50,
          destinationType: this.camera.DestinationType.FILE_URI,
          sourceType: this.params.isCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY,
          allowEdit: false,
          encodingType: this.camera.EncodingType.JPEG,
          targetWidth: 300,
          targetHeight: 300,
          saveToPhotoAlbum: false,
          cameraDirection: 1,
          correctOrientation: true
        };

        const imageData = await this.cameraNative.getCamera(options);

        if (imageData.cancelled) {
          attNativeRecord.cancelled = true;
        } else {
          attNativeRecord.camera.base64Image = imageData.base64Image;
          attNativeRecord.camera.nativeURL = imageData.nativeURL;
        }

        resolve(attNativeRecord);
      } catch (error) {
        console.log('TCL: error', error);
        attNativeRecord.cancelled = true;
        resolve(attNativeRecord);
      }
    })
  }

  getCameraDevice(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let pictureData: any;
        const options: CameraOptions = {
          quality: 50,
          destinationType: this.camera.DestinationType.FILE_URI,
          sourceType: this.params.isCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY,
          allowEdit: false,
          encodingType: this.camera.EncodingType.JPEG,
          targetWidth: 300,
          targetHeight: 300,
          saveToPhotoAlbum: false,
          cameraDirection: 1,
          correctOrientation: true
        };

        const imageData = await this.camera.getPicture(options);

        try {
          const getFilePath = this.globalServiceProvider.getFilePath(imageData);
          const uriToFile = await this.globalServiceProvider.convertUriToFile(getFilePath.path, getFilePath.filename);
          const fileToBase64 = await this.globalServiceProvider.convertFileToBase64(uriToFile);
          this.params.imageBase64 = fileToBase64;
        } catch (error) { }

        this.reloadStatusBar();
        this.params.statusPicture = true;
        this.params.imageData = imageData;
        pictureData = await this.savePicture();
        resolve(pictureData);
      } catch (error) {
        this.reloadStatusBar();
        let msgError = 'error plugin camera';

        try {
          msgError = error.toString();
        } catch (error) { }

        this.alertService.createMola(msgError)
        resolve(false)
      }
    })
  }

  savePicture() {
    return new Promise(async (resolve) => {
      if (this.params.statusPicture == true) {
        let date = new Date().getFullYear() + new Date().getMonth() + new Date().getDate();
        let time = new Date().getTime();
        let userId = this.SFGoAuth && this.SFGoAuth.userId ? this.SFGoAuth.userId : 'not_login_yet';
        let defaultFileName = 'img_gd_' + userId + '_' + date + '_' + time + '.jpg';
        let currentTime = await this.getCurrentTime();
        let formatResultData = await this.formatResultData(defaultFileName, currentTime, 'online');

        resolve(formatResultData);
      } else {
        if (this.params.setting.takePhoto) {
          let results = await this.confirmWithOutCamera();
          resolve(results);
        } else {
          let currentTime = await this.getCurrentTime();
          let formatResultData = await this.formatResultData('', currentTime, 'online');
          resolve(formatResultData);
        }
      }
    })
  }

  getCurrentTime() {
    return new Promise(async (resolve) => {
      this.SFGoStorage = await this.sfgoAuthService.getGDStorage();
      const storedPrelogin = this.SFGoStorage ? this.SFGoStorage.storedPrelogin : {};

      if (storedPrelogin.hasOwnProperty('GOPATHNEW')) {
        this.attendanceApi.getCurrentTime().timeout(5000).subscribe(async (result: any) => {
          resolve(result.data);
        }, async error => {
          resolve(new Date().toISOString());
        });
      } else {
        this.sfattendanceApi.getCurrentTime().timeout(5000).subscribe(async (result: any) => {
          resolve(result.hasil.time);
        }, async error => {
          resolve(new Date().toISOString());
        });
      }
    })
  }

  formatResultData(options, datetime, attOn: string = 'online'): Promise<ResponseAttendanceMachine> {
    return new Promise(async (resolve) => {
      let deviceInfo = 'web';
      let appVersion = 'web'

      if (this.platform.is('cordova')) {
        deviceInfo = await this.platformServiceProvider.getPlatform();
        appVersion = await this.appVersion.getVersionNumber();
      }

      let data: ResponseAttendanceMachine = {
        id: (new Date().getTime()).toString(36).toLowerCase(),
        datetime: datetime,
        status: null,
        isRunning: null,
        isbarcode: this.params.isBarcode || false,
        barcode: this.params.barcodeData || null,
        imageBase64: this.params.imageBase64,
        imageFile: null,
        photo: null,
        photoUrl: this.params.imageData,
        options: options,
        data: this.params.data,
        geolocation: this.params.geolocation,
        attOn: attOn,
        setBasePhoto: false,
        faceRecognition: {
          accuration: 0,
          liveness: null,
          livenessTreshold: 0.5,
          livenessCrashCount: 0,
          deviceInfo: deviceInfo !== 'web' ? JSON.stringify(deviceInfo) : deviceInfo,
          gdVersion: appVersion
        },
      };

      try {
        // Get address by coordinate location
        const attendanceAddress = this.attendanceSetting.attendanceAddress || false;
        if (attendanceAddress && data.geolocation && data.geolocation.latitude && data.attOn === 'online') {
          const latitude = data.geolocation.latitude;
          const longitude = data.geolocation.longitude;
          data.geolocation.address = await this.getAddress(
            latitude,
            longitude
          );
        }
      } catch (_) { }

      // Face spoofing
      if (this.platform.is('cordova') && this.platform.is('android') && this.params.setting.attendanceFaceLiveness) {
        try {
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_FACE_SPOOFING, Number(moment().format('ss')));
          const counterSpoof = await this.decrementCouterFaceSpoof();
          const attempLiveness = this.params.setting.attendanceFaceLivenessAttempt;
          let livenessCrashCount = counterSpoof;
          if (counterSpoof <= attempLiveness) {
            data.faceSpoofing = await this.faceSpoofingNative.detect(data.photoUrl);
            console.log('faceSpoofing', data.faceSpoofing)
            data.faceSpoofing.scorePercentage = (Number(data.faceSpoofing.score) * 100).toFixed(2);
            data.faceSpoofing.liveness = this.checkLiveness(data.faceSpoofing.scorePercentage);
            data.faceRecognition.liveness = data.faceSpoofing.score;
            data.faceRecognition.livenessTreshold = data.faceSpoofing.threshold;
            livenessCrashCount = await this.incrementCouterFaceSpoof(counterSpoof);
          }

          data.faceRecognition.livenessCrashCount = livenessCrashCount;
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_FACE_SPOOFING_SUCCESS, Number(moment().format('ss')));
        } catch (error) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_FACE_SPOOFING_FAILED, Number(moment().format('ss')));
        }
      }

      // check work location
      await this.checkFormWorklocation();

      if (options != '' && this.params.imageData != 'undefined' && this.params.imageData != '') {
        const getPathAttendance = await this.permissionCheckProvider.getPathAttendance();
        const newPath = getPathAttendance.nativeURL;
        const oldPath = encodeURI(this.params.imageData.replace(this.params.imageData.substr(this.params.imageData.lastIndexOf('/') + 1), ''));
        const newFileName = options.fileName;
        const oldFileName = this.params.imageData.substr(this.params.imageData.lastIndexOf('/') + 1);
        const oldFullPath = this.params.imageData;

        try {
          const entry: Entry = await this.file.copyFile(oldPath, oldFileName, newPath, newFileName);
          data.photoUrl = entry.nativeURL;
          this.removeFile(oldFullPath);
        } catch (error) {
        }

        resolve(data);
      } else {
        resolve(data);
      }
    })
  }

  async checkFormWorklocation(): Promise<void> {
    if (this.params.setting.wlc) {
      const getLoadingTodayForm = await this.appPreferences.getGreatdayStorage(Preference.GDAttendanceTodayFormIsLoading);
      const todayForm = await this.appPreferences.getGreatdayStorage(Preference.GDAttendanceTodayForm);
      if (getLoadingTodayForm == true && !todayForm) {
        await this.worklocationService.todayForm();
      }
    }
  }

  checkLiveness(score: number): boolean {
    const livenessTreshold = Number(this.attendanceSetting.attendanceFaceLivenessTreshold) || 50;
    console.log('livenessTreshold', livenessTreshold);
    const threshold = livenessTreshold > 0 && livenessTreshold <= 1 ? (livenessTreshold * 100) : livenessTreshold;
    console.log('threshold', threshold);
    return Number(score) <= threshold ? true : false;
  }

  async decrementCouterFaceSpoof() {
    let counterSpoof: number = await this.appPreferences.getGreatdayStorage<number>(Preference.GDCounterFaceSpoofing) || 0;
    const attempLiveness = this.params.setting.attendanceFaceLivenessAttempt;
    if (counterSpoof < attempLiveness) {
      counterSpoof++;
      await this.appPreferences.setGreatdayStorage(Preference.GDCounterFaceSpoofing, counterSpoof);
    } else if (counterSpoof > attempLiveness) {
      await this.appPreferences.setGreatdayStorage(Preference.GDCounterFaceSpoofing, 0);
    }

    return counterSpoof;
  }

  async incrementCouterFaceSpoof(counterSpoof: number) {
    if (counterSpoof > 0) counterSpoof--;
    await this.appPreferences.setGreatdayStorage(Preference.GDCounterFaceSpoofing, counterSpoof);
    return counterSpoof;
  }

  saveQRCode(dataRecord, dateTime, image, options): Promise<any> {
    return new Promise((resolve) => {
      let item = {
        id: (new Date().getTime()).toString(36).toLowerCase(),
        status: null,
        isbarcode: true,
        barcode: this.params.data,
        geolocation: (this.params.geolocation != '') ? this.params.geolocation : {},
        photo: this.params.imageData,
        photoUrl: this.params.imageData,
        options: options,
        datetime: moment(this.myDate).toISOString()
      };

      if (this.isSF6) {
        this.storage.get('SFGoAuth').then(hasil => {
          this.SFGoAuth = JSON.parse(hasil);
          this.sfattuploadsf6Api.SendQRCode(this.params.data, this.SFGoAuth.companyId, this.params.flagButton, dateTime, image, this.params.geolocation, 'online')
            .subscribe(async (result) => {
              if (result.hasil.success === true) {
                let concatMsg = result.hasil.empNo === 'DataInQue' ? 'AlertQueAttendance' : 'Time recorded successfully\n' + result.hasil.fullName + ' [' + result.hasil.empNo + ']';
                this.toastService.create(concatMsg, 3000, 'bottom');
                resolve(true);
              } else {
                let toastCallBack = await this.toastWarningRunAttendanceOffline(result.hasil.message, item);
                resolve(toastCallBack);
              }
            }, async (error) => {
              let toastCallBack = await this.toastWarningRunAttendanceOffline(error.message, item);
              resolve(toastCallBack);
            })
        });
      } else {
        this.sfattendanceApi.qrCodeAttendance(dataRecord).subscribe(async (result) => {
          if (result.hasil.success === true) {
            let concatMsg = result.hasil.empNo === 'DataInQue' ? 'AlertQueAttendance' : 'Time recorded successfully\n' + result.hasil.fullName + ' [' + result.hasil.empNo + ']';
            this.toastService.create(concatMsg, 3000, 'bottom');
            resolve(true);
          } else {
            let toastCallBack = await this.toastWarningRunAttendanceOffline(result.hasil.message, item);
            resolve(toastCallBack);
          }
        }, async (error) => {
          let toastCallBack = await this.toastWarningRunAttendanceOffline(error.message, item);
          resolve(toastCallBack);
        });
      }
    })
  }

  toastWarningRunAttendanceOffline(message, item): Promise<any> {
    return new Promise((resolve) => {
      this.toastService.createToastCallback(message, 3000, 'bottom', async () => {
        let runAttendanceOffline = await this.runAttendanceOffline(item);
        resolve(runAttendanceOffline);
      });
    })
  }

  confirmWithOutCamera() {
    return new Promise(async (resolve) => {
      /**
       * cameraLock = true => without alert skip , false => with alert skip , cameraLock default is false
       */
      let cameraLock: boolean = this.params.setting.cameraLock;
      if (cameraLock) {
        resolve(false);
      } else {
        const confirm = await this.alertService.confirmMola('Camera cancelled. Want to continue record time?', 'Cancel', 'Next');
        if (confirm) {
          if (this.params.isBarcode) {

          } else {
            this.sfattendanceApi.getCurrentTime().subscribe(result => {
              resolve({
                datetime: result.hasil.time,
                photo: '',
                imageData: '',
                options: '',
                data: this.params.data,
                geolocation: this.params.geolocation
              })
            }, error => {
              resolve({
                datetime: new Date().toISOString(),
                photo: '',
                imageData: '',
                options: '',
                data: this.params.data,
                geolocation: this.params.geolocation
              })
            })
          }
        } else {
          resolve(false);
        }
      }
    })
  }

  checkValidationCover(isOnline?: boolean) {
    return new Promise(async (resolve) => {
      try {
        let isAttendanceLock = (typeof this.params.setting.attendanceLock != 'undefined') ? this.params.setting.attendanceLock : this.params.setting.attendanceLock;
        let isAttendanceLockPrompt = (typeof this.params.setting.attendanceLock != 'undefined') ? this.params.setting.attendanceLockPrompt : this.params.setting.attendanceLockPrompt;
        let isCover: boolean;
        let result = true;

        // check geoFence
        if (isOnline) {
          if (isAttendanceLock || isAttendanceLockPrompt) {
            isCover = await this.checkGeoFenceIsCoverage(this.SFGoAuth.empId, this.params.geolocation.latitude, this.params.geolocation.longitude);
          } else {
            isCover = true;
          }
        }

        if (isCover == false) {
          if (this.params.setting && this.params.setting.attendanceLockPrompt && !this.params.setting.attendanceLock) {
            const confirm = await this.alertService.confirmMola(Messages.OUTSIDE_ATTENDANCE_AREA, 'Close', 'Next');
            if (confirm) {
              //GA
              this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_LOCATION_RADIUS, 'Next');
            } else {
              //GA
              this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_LOCATION_RADIUS, 'Close');
            }

            result = confirm ? true : false;
          } else {
            await this.alertService.createMola(Messages.OUTSIDE_ATTENDANCE_AREA);
            result = false;
          }

          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_LOCATION_RADIUS, 'Outside Attendance Area');
        }

        resolve(result)
      } catch (error) {
        resolve(true);
      }
    });
  }

  showAlertMocklocation(mock: boolean) {
    return new Promise(async (resolve) => {
      if (mock) {
        const message = 'We\'ve detected that there are other apps in the device, which are using Mock Location access (Location Spoofing Apps). Please uninstall first.';
        await this.alertService.createMola(message);
        resolve(false)
      } else {
        resolve(true);
      }
    });
  }

  checkGeolocation(geolocation) {
    return new Promise(async (resolve) => {
      if (!this.params.geolocation || !geolocation.latitude || !geolocation.longtitude) {
        const confirm = await this.alertService.confirmMola('Error Getting Location', 'Cancel', 'Try Again');
        if (confirm) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_LOCATION_RADIUS, 'Outside Attendance Area');
          this.recordAttendance().then((res) => {
            resolve(res);
          });
        } else {
          resolve(true);
        }
      } else {
        resolve(true);
      }
    })
  }

  formatDate() {
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('');
  }

  makeid() {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let i = 0; i < 12; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  processWebImage(event?: any): Promise<any> {
    return new Promise(async (resolve) => {
      let loading = this.loadingCtrl.create();
      loading.present();

      this.SFGoAuth = await this.sfgoAuthService.getAuthorization();

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          loading.dismiss();
          this.params.geolocation = {
            latitude: position.coords && position.coords.latitude ? position.coords.latitude.toString() : '0',
            longitude: position.coords && position.coords.longitude ? position.coords.longitude.toString() : '0'
          };

          // Get setting service attendance
          let GDAttendanceSetting = await this.getAttendanceSetting();
          this.params.setting = GDAttendanceSetting;

          // Check setting access user can absent from web or not
          if (!this.params.setting.webAbsent) {
            let msg = this.translate.instant(Messages.CANNOT_ALLOWED_RECORD_ATTENDANCE_FROM_WEB);
            this.alertService.createMola(msg)
            resolve(false);
          }

          // check geoFence
          let checkCover = await this.checkValidationCover(true);
          if (checkCover != true) {
            resolve(false);
            return false;
          }

          let fileName = 'img_web_' + this.formatDate() + '_' + new Date().getTime() + '.jpg';
          let currentTime = await this.getCurrentTime();
          let base64Image = event && event.base64Image ? event.base64Image : '';
          let blob = event && event.file ? event.file : '';

          let result: ResponseAttendanceMachine = {
            id: (new Date().getTime()).toString(36).toLowerCase(),
            datetime: currentTime,
            status: null,
            isRunning: null,
            isbarcode: this.params.isBarcode || false,
            barcode: this.params.barcodeData || null,
            imageBase64: base64Image,
            imageFile: null,
            photo: null,
            setBasePhoto: false,
            photoUrl: base64Image,
            options: '',
            data: '',
            blob: blob,
            geolocation: this.params.geolocation,
            attOn: 'online',
            faceRecognition: {
              accuration: 0,
              liveness: null,
              livenessTreshold: 0.5,
              livenessCrashCount: 0,
              deviceInfo: 'web',
              gdVersion: 'web version'
            },
          };

          // check work location
          await this.checkFormWorklocation();

          // check params event imageexists, if exists define options with filename
          if (event) result.options = fileName;
          resolve(result);
        }, error => {
          loading.dismiss();
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.toastService.create('User denied the request for Geolocation.', 5000, 'bottom');
              break;
            case error.POSITION_UNAVAILABLE:
              this.toastService.create('Location information is unavailable.', 5000, 'bottom');
              break;
            case error.TIMEOUT:
              this.toastService.create('The request to get user location timed out.', 5000, 'bottom');
              break;
            default:
              this.toastService.create('An unknown error occurred.', 5000, 'bottom');
              break;
          }
          resolve(false);
        }, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        });
      } else {
        loading.dismiss();
        this.toastService.create('Geolocation is not supported by this browser.', 5000, 'bottom');
        resolve(false);
      }

    });
  }

  processWebWithOutImage(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        var boolean = await this.funRunCheckWebabsent();
        if (!boolean) {
          return false;
        }
      } catch (error) {
        return false;
      }

      let loading = this.loadingCtrl.create();
      loading.present();

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async(position) => {
          loading.dismiss();
          let geolocation = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };

          // check work location
          await this.checkFormWorklocation();
          this.sfattendanceApi.getCurrentTime().subscribe((result) => {
            resolve({
              datetime: result.hasil.time,
              photo: '',
              imageData: event,
              options: '',
              data: '',
              geolocation: geolocation
            })
          }, error => {
            resolve({
              datetime: new Date().toISOString(),
              photo: '',
              imageData: event,
              options: '',
              data: '',
              geolocation: geolocation
            })
          })
        }, error => {
          loading.dismiss();
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.toastService.create('User denied the request for Geolocation.', 5000, 'bottom');
              break;
            case error.POSITION_UNAVAILABLE:
              this.toastService.create('Location information is unavailable.', 5000, 'bottom');
              break;
            case error.TIMEOUT:
              this.toastService.create('The request to get user location timed out.', 5000, 'bottom');
              break;
            default:
              this.toastService.create('An unknown error occurred.', 5000, 'bottom');
              break;
          }
        }, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        });


      } else {
        loading.dismiss();
        this.toastService.create('Geolocation is not supported by this browser.', 5000, 'bottom');
      }

    });
  }

  funRunCheckWebabsent(event: any = '') {
    return new Promise((resolve, reject) => {
      this.settingServiceApi.checkWebabsent().subscribe((val) => {
        if (val) {
          resolve(true)
        } else {
          let msg = 'error_message:Can\'t be absent through the web';
          this.alertService.createWarnMola(msg).then((result) => {
            this.alertService.redirect(msg)
          })
        }
      }, error => {
        let msg = 'error_message:Error when checking';
        this.alertService.createWarnMola(msg).then((result) => {
          this.alertService.redirect(error.message)
        })
      })
    })
  }

  checkRoot(): Promise<any> {
    return new Promise((res, rej) => {
      try {
        if (this.platform.is('ios')) {
          SecurityCheck.isJailbrokenDetected((data) => {
            res(data);
          }, (error) => {
            rej(error)
          });
        } else {
          IRoot.isRooted((booleanVal) => {
            res(booleanVal);
          }, (err) => {
            rej(err)
          });

        }
      } catch (e) {
        rej(e)
      }
    })
  }

  checkDeveloperOptions() {
    return new Promise(async (resolve) => {
      try {
        greatdayplugin.isDevelopmentSettingsEnabled((response) => {
          resolve(response);
        }, () => {
          resolve(false);
        });
      } catch (error) {
        resolve(false);
      }
    });
  }

  openDeveloperOptions() {
    greatdayplugin.openDeveloperOptions(() => { }, () => { });
  }

  getCompanySetting(): Promise<any> {
    return new Promise((resolve) => {
      this.settingApi.getCompanySetting()
        .subscribe(async (data) => {
          await this.storage.set('GDAttendanceSetting', JSON.stringify(data.data));
          await this.storage.set('GDCheckRoot', JSON.stringify(data.data));
          this.getAttendanceSetting();
          resolve(data.data)
        }, async (_) => {
          const storage = await this.storage.get('GDAttendanceSetting');
          if (!storage) {
            this.storage.set('GDAttendanceSetting', JSON.stringify(this.params.setting));
          }
          resolve(null);
        })
    })
  }

  checkGeoFenceIsCoverage(empId: string, lat: number, lng: number): Promise<boolean> {
    return new Promise<boolean>(res => {
      this.attendanceApi.checkLocation({
        empId: empId,
        lat: Number(lat),
        lng: Number(lng)
      }).pipe(map(response => response.data))
        .subscribe(data => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_LOCATION_RADIUS, data.isCoverageArea);
          res(data.isCoverageArea)
        }, error => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_CHECK_LOCATION_RADIUS, error);
          res(true)
        })
    })
  }

  checkMock(whiteList): Promise<{ isMock: boolean, messages?: string, indicated?: Array<String> }> {
    return new Promise<{ isMock: boolean, messages?: string, indicated?: Array<String> }>(res => {
      mockchecker.check(whiteList, success => res(success), failed => res(failed))
    })
  }

  removeFile(file: string) {
    let path = file.substring(0, file.lastIndexOf('/') + 1);
    let fileName = file.substring(file.lastIndexOf('/') + 1);

    this.file.removeFile(path, fileName).then((result) => {
    }).catch(error => {
    });
  }

  runAttendanceOffline(item): Promise<any> {
    return new Promise(async (resolve) => {
      if (this.platform.is('cordova')) {
        const confirm = await this.alertService.confirmMola('Do you want to keep the record offline?', 'Cancel', 'OK');
        if (confirm) {
          const save = await this.saveAttedanceOffline(item);
          resolve(save);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    })
  }

  saveAttedanceOffline(item): Promise<any> {
    return new Promise((resolve) => {
      this.storage.get('SFGoAttendanceLog')
        .then(async (attendance) => {

          if (attendance != null && attendance != undefined) {
            let data = JSON.parse(attendance);
            data.push(item);
            this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
          } else {
            let data = [];
            data.push(item);
            this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
          }

          await this.alertService.createMola('Your attendance record is already saved');
          resolve(false);
        });
    })
  }

  findAttWorkLocation(): Promise<any> {
    return new Promise(async (resolve) => {
      const isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
      if (isGoPathNewExist) {
        this.attWorkLocationApi.findAttWorkLocation().subscribe(
          async result => {
            const attWorkLocationFormat = await this.attWorkLocationFormater(result.data);
            const objData = { data: attWorkLocationFormat };
            this.storage.set('attWorkLocation', JSON.stringify(objData));
            resolve(true);
          }, error => {
            resolve(true);
          }
        )
      } else {
        this.workLocationApi.findAttWorkLocation().subscribe(async (result: any) => {
          const attWorkLocationFormat = await this.attWorkLocationFormater(result.data);
          const objData = { data: attWorkLocationFormat };
          this.storage.set('attWorkLocation', JSON.stringify(objData));
          resolve(true);
        }, error => {
          resolve(true);
        })
      }
    })
  }

  attWorkLocationFormater(data: Array<any>): Promise<any> {
    return new Promise((resolve) => {
      let tempData: Array<any> = []

      if (data.length > 0) {
        for (let item of data) {
          if (item.latitude != null && item.latitude != undefined && item.latitude != '') {
            let obj = {
              work_lat: item.latitude,
              work_lon: item.longitude,
              work_radius: item.maxRadius,
              work_type: item.type,
              work_name: item.locationName || item.locationCode,
            }
            tempData.push(obj);
          }
        }
      }
      resolve(tempData)
    })
  }

  uploadPhoto(item: ResponseAttendanceMachine) {
    return new Promise<string>(async (resolve) => {
      const auth = await this.sfgoAuthService.getAuthorization();
      this.storagePathProvider.getStorageAttendance(auth, auth.userId)
        .then(async (val) => {
          try {
            item = await this.createImageSource(item);

            const options: OptionsUploadWithHttp = {
              nativeURI: item.imageFile,
              eventsWebview: item.imageFile,
              type: 'image',
              options: item.options
            }

            const result = await this.fileUploaderProvider.uploadWithHttp(options, val.urlUpload);
            this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_SUCCESS_UPLOAD, 'Success Upload Photo', (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
            resolve(result);
          } catch (error) {
            await this.appPreferences.setErrorMessage(error);
            //GA
            this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_FAILED_UPLOAD, error, (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
            resolve(null);
          }
        })
        .catch(async (error) => {
          await this.appPreferences.setErrorMessage(error);
          resolve(null);
        })
    })
  }

  async createImageSource(item: ResponseAttendanceMachine) {
    if (!this.platform.is('cordova')) {
      item.imageFile = await this.globalServiceProvider.convertBase64toBlob(item.photoUrl);
    } else {
      try {
        if (item.imageBase64) {
          item.imageFile = await this.globalServiceProvider.convertBase64toBlob(item.imageBase64);
        } else if (item.photoUrl) {
          item.imageFile = item.photoUrl;
        }
      } catch (error) {
        item.imageFile = item.photoUrl;
      }
    }

    return item;
  }

  uploadPhotoNative(item) {
    return new Promise<string>((resolve) => {
      if (!item.options) {
        try {
          let photoUrl = item.photoUrl;
          item.options = {
            fileKey: 'file',
            fileName: photoUrl.substring(photoUrl.lastIndexOf('/') + 1),
            chunkedMode: false,
            mimeType: 'image/jpg'
          }
        } catch (error) {
        }
      }

      const fileTransfer: FileTransferObject = this.transfer.create();
      const path = item.photoUrl.substring(0, item.photoUrl.lastIndexOf('/') + 1);
      const fileName = item.photoUrl.substring(item.photoUrl.lastIndexOf('/') + 1);

      this.file.checkFile(path, fileName)
        .then(() => {
          fileTransfer.upload(item.photoUrl, item.urlUpload, item.options)
            .then(async (result) => {
              const response = JSON.parse(result['response']);
              const fileName = response.hasOwnProperty('data') && response.data ? response.data.fileName : JSON.parse(result['response']).result.files.file[0].name;
              this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_SUCCESS_UPLOAD, 'Success Upload Photo', (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
              await this.appPreferences.setDefaultPhotoAttendance(fileName);
              resolve(fileName);
            }).catch(async error => {
              try {
                const options: OptionsUploadWithHttp = {
                  nativeURI: item.photoUrl,
                  type: 'image',
                  options: fileName,
                  eventsWebview: null
                }

                const filename = await this.fileUploaderProvider.uploadWithHttp(options, item.urlUpload);
                resolve(filename);
              } catch (error) {
                await this.appPreferences.setErrorMessage(error);
                //GA
                this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_FAILED_UPLOAD, error, (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
                resolve(null);
              }
            })
        })
        .catch(async (error) => {
          await this.appPreferences.setErrorMessage(error);
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_FAILED_UPLOAD, error, (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
          const image = await this.appPreferences.getDefaultPhotoAttendance();
          resolve((image) ? image : 'gd-file-not-found.jpg');
        })
    })
  }

  uploadPhotoWeb(item, isAWS?: boolean) {
    return new Promise<string>(async (resolve) => {
      item.photoUrl = await this.globalServiceProvider.convertBase64toBlob(item.photoUrl);
      const formData = new FormData();
      const isGopathNew = await this.sfgoAuthService.isGopathNew();

      if (isGopathNew || isAWS) {
        formData.append('file', item.blob, item.options);
      } else {
        formData.append('file[]', item.blob, item.options);
      }

      this.http.post(item.urlUpload, formData)
        .subscribe((response: any) => {
          const fileName = response.hasOwnProperty('data') && response.data ? response.data.fileName : response.result.files.file[0].name;
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_SUCCESS_UPLOAD, 'Success Upload Photo', (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
          resolve(fileName);
        }, async error => {
          //GA
          await this.appPreferences.setErrorMessage(error);
          this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_FAILED_UPLOAD, error, (performance.now() - performance.getEntriesByName('apiStart')[0].startTime));
          resolve(null)
        });
    });
  }

  checkAutomaticDateTime(): Promise<any> {
    return new Promise((resolve) => {
      try {
        autostartmanager.checkAutomaticDateTimeZone(function (isIt) {
          if (isIt == 'true') {
            resolve(true)
          } else {
            resolve(false);
          }
        });
      } catch (error) {
        resolve(false);
      }
    })
  }

  getFileDirectoryAttendance(): Promise<Array<any>> {
    return new Promise(async (resolve) => {
      let result = [];
      try {
        result = await this.file.listDir(this.file.dataDirectory, 'Attendance');
      } catch (error) {
        console.log(error);
      }
      resolve(result);
    })
  }

  getAttendanceSetting(): Promise<AttendanceSettingService> {
    return new Promise(async (resolve) => {
      // Get setting service attendance
      await this.platform.ready();
      let GDAttendanceSetting = await this.storage.get('GDAttendanceSetting');
      let attendanceSetting: AttendanceSettingService = (GDAttendanceSetting && GDAttendanceSetting != '{}') ? JSON.parse(GDAttendanceSetting) : this.params.setting;

      // create default setting for object not exists in storage
      if (!attendanceSetting.hasOwnProperty('takePhoto')) {
        attendanceSetting.takePhoto = true;
      }

      if (!attendanceSetting.hasOwnProperty('offlineMode')) {
        attendanceSetting.offlineMode = true;
      }

      if (!attendanceSetting.hasOwnProperty('checkAutoTime')) {
        attendanceSetting.checkAutoTime = true;
      }

      if (!attendanceSetting.hasOwnProperty('checkFakeGPS')) {
        attendanceSetting.checkFakeGPS = true;
      }

      if (!attendanceSetting.hasOwnProperty('webAbsent')) {
        attendanceSetting.webAbsent = true;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceLockPrompt')) {
        attendanceSetting.attendanceLockPrompt = false;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceAddress')) {
        attendanceSetting.attendanceAddress = false;
      }

      if (!attendanceSetting.hasOwnProperty('skipErrorLocation')) {
        attendanceSetting.skipErrorLocation = false;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceFaceBlock')) {
        attendanceSetting.attendanceFaceBlock = false;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceFace')) {
        attendanceSetting.attendanceFace = false;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceFaceLiveness')) {
        attendanceSetting.attendanceFaceLiveness = false;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceFaceLivenessBlocking')) {
        attendanceSetting.attendanceFaceLivenessBlocking = false;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceFaceLivenessTreshold')) {
        attendanceSetting.attendanceFaceLivenessTreshold = 0.5;
      }

      if (!attendanceSetting.hasOwnProperty('attendanceFaceLivenessAttempt')) {
        attendanceSetting.attendanceFaceLivenessAttempt = 3;
      }

      if (!attendanceSetting.hasOwnProperty('wlc')) {
        attendanceSetting.wlc = false;
      }

      this.attendanceSetting = attendanceSetting;
      resolve(attendanceSetting);
    })
  }

  get attendanceSetting() {
    return this.tempAttendanceSetting
  }

  set attendanceSetting(setting) {
    this.tempAttendanceSetting = setting
  }

  /** for temporary attendace */
  async attendanceSaveToStorage(dataRecord): Promise<any> {
    await this.storage.ready();
    if (!this.attendanceSetting) this.getCompanySetting();
    if (this.attendanceSetting.offlineMode) {
      const attendance = await this.storage.get('SFGoAttendanceLog');
      let data = [];

      if (attendance != null && attendance != undefined) {
        data = JSON.parse(attendance);
        data.push(dataRecord);
        await this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
      } else {
        data.push(dataRecord);
        await this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
      }

      return data;
    }
  }

  async attendanceRemoveTempStorage(dataRecord): Promise<any> {
    await this.storage.ready();
    const attendance = await this.storage.get('SFGoAttendanceLog');
    let data = [];

    if (attendance != null && attendance != undefined) {
      const idx = data.findIndex((item) => item.id == dataRecord.id);

      data = JSON.parse(attendance);
      data.splice(idx, 1);
      await this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
    }
    return data
  }

  async checkTracker() {
    try {
      const isPositionTracker = await this.trackerApi.checkTracker().toPromise();
      await this.storage.set('isPositionTracker', isPositionTracker.data);
    } catch (e) {
      await this.storage.set('isPositionTracker', false);
    }
  }

  async runTracker() {
    try {
      if (this.SFGoAuth.menu['tracking']) {

        // check google playservice
        if (!this.globalServiceProvider.getIsGooglePlayServicesAvailable()) {
          await this.alertService.createMola(Messages.TRACKING_GOOGLE_PLAYSERVICE_NOT_AVAILABLE);
          return Promise.resolve(null);
        }

        const flexibleTracker = this.SFGoAuth.companySetting.flexibleTracking || false;
        const isRunning = await this.backgroundGeolocationBloc.checkStatus();
        if (flexibleTracker && isRunning) {
          await this.stopTracker();
          return Promise.resolve(null);
        }

        const checkShiftTracker = await this.trackerApi.checkShiftTracker().toPromise();
        if (checkShiftTracker.data) {
          await this.backgroundGeolocationBloc.initBackGroundLocation();
          await this.backgroundGeolocationNative.start();
          this.trackerBloc.startIntervalTracker();
          const toast = this.toastTracker();
          return Promise.resolve(toast);
        } else {
          await this.stopTracker();
          return Promise.resolve(null);
        }
      }
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  async stopTracker() {
    try {
      this.backgroundGeolocationNative.stop();
      const location = await this.geolocationNative.getCurrentPosition({
        enableHighAccuracy: true
      });
      await this.trackerApi.end([{
        empId: this.SFGoAuth.empId,
        location: {
          longitude: location.coords.longitude.toString(),
          latitude: location.coords.latitude.toString(),
        },
        logTime: moment().format(),
      }]).toPromise();
    } catch (e) {
    }
  }

  toastTracker() {
    return this.toastCtrl.create({
      message: this.translate.instant('Tracking has been activated'),
      position: 'bottom',
      showCloseButton: true,
      closeButtonText: this.translate.instant('Detail'),
      cssClass: 'toast-white',
      dismissOnPageChange: true,
      // duration: 10000,
    })
  }

  reloadStatusBar() {
    this.statusBar.hide();
    this.statusBar.show();
  }

  setShowBreakTime(value: boolean) {
    this.showBreakTime = value;
  }

  getShowBreakTime(): boolean {
    return this.showBreakTime;
  }

  async myAttendanceData(payload): Promise<void> {
    return new Promise<any>(async (resolve, reject) => {
      this.attendanceApi.myAttendanceData({
        startdate: payload.startdate,
        enddate: payload.enddate,
        empId: payload.empId
      }).subscribe(result => {
        resolve(result.data);
      }, error => {
        reject()
      }
      )
    })
  }

  /**
 * Handle message attendance for integrated (sf6)
 * @param obj
 */
  sf6AttendanceMessage(obj, dataRecord) {
    let message = dataRecord && dataRecord.attBreak ? Messages.SUCCESS_SAVED_BREAKTIME : Messages.SUCCESS_SAVED_ATTENDANCE;
    if (obj.hasOwnProperty('message')) {
      /** handle message from api nest */
      if (obj.message) {
        if (obj.message == 'DataInQue') {
          message = Messages.ALERTQUEATTENDANCE;
        } else {
          message = obj.message;
        }
      }
    } else {
      /** handle message from api loopback */
      if (obj.status === undefined) {
        message = Messages.SUCCESS_SAVED_ATTENDANCE;
      } else {
        /** handle message queuing */
        if (obj.message == 'DataInQue') {
          message = Messages.ALERTQUEATTENDANCE;
        } else {
          message = obj.message;
        }
      }
    }

    return message
  }

  messageSuccessAttendance(auth, result, dataRecord) {
    let message: string = Messages.SUCCESS_SAVED_ATTENDANCE;
    if (auth.isSF6) {
      message = this.sf6AttendanceMessage(result, dataRecord)
    } else {
      if (dataRecord && dataRecord.attBreak) {
        message = Messages.SUCCESS_SAVED_BREAKTIME;
      }
    }

    return message;
  }

  covid19ZoneApi(payload: { latitude: number, longitude: number }) {
    return new Promise<ResponseCovid19Zone>((resolve, reject) => {
      this.http.post<ResponseData<ResponseCovid19Zone>>('https://integration.greatdayhr.com/newsubscription/covid19-zone', { latitude: Number(payload.latitude), longitude: Number(payload.longitude) })
        .map(res => res.data)
        .subscribe((response) => {
          resolve(response)
        }, error => {
          reject(error)
        })
    })
  }

  getNewTodayAttendance(payload: RequestAttendanceTempDto) {
    return new Promise<ResponseNewTodayAttendance>((resolve, reject) => {
      this.attendancesApi.getNewTodayAttendance(payload)
        .map(response => response.data)
        .subscribe(result => {
          resolve(result);
        }, error => {
          reject(error);
        })
    })
  }

  doGetTodayAttendance(empId): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const params = {
          date: new Date().toISOString(),
          empId: empId
        }

        this._loadingGetTodayAttendance = true;
        const result = await this.getNewTodayAttendance(params);
        this._todayAttendance.today = result.today;
        this._todayAttendance.yesterday = result.yesterday;

        // trigger show rating
        this._feedBack = result.today.feedback;
        this._loadingGetTodayAttendance = false;
        resolve();
      } catch (error) {
        this._loadingGetTodayAttendance = false;
        reject(error)
      }
    });
  }

  doGetTodayShift(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let result = await this.getTodayShift();
        if (result.success) {
          this._todayShift.newshiftname = result.result.shiftdailyname;
          this._todayShift.newshiftcode = result.result.shiftdailycode;
          this._todayShift.newshiftstart = result.result.shiftstarttime;
          this._todayShift.newshiftend = result.result.shiftendtime;
          this._todayShift.shiftBreak = result.result.shiftBreak || [];
        } else {
          this._todayShift.newshiftname = null;
          this._todayShift.newshiftcode = null;
          this._todayShift.newshiftstart = null;
          this._todayShift.newshiftend = null;
        }
        resolve(true);
      } catch (error) {
        this._todayShift.newshiftname = null;
        this._todayShift.newshiftcode = null;
        this._todayShift.newshiftstart = null;
        this._todayShift.newshiftend = null;
        resolve(true)
      }
    })
  }

  get loadingGetTodayAttendance() {
    return this._loadingGetTodayAttendance;
  }

  get todayAttendance() {
    return this._todayAttendance;
  }

  get todayShift() {
    return this._todayShift;
  }

  get feedBack() {
    return this._feedBack;
  }

  setFuncAuthAttendance(auth: GDAuthInterface): void {
    try {
      const listMenu = auth.menu;
      if (listMenu) {
        this._funcAuthAttendance.showAE = listMenu["att-entry"];
        this._funcAuthAttendance.showAC = listMenu["att-correction"];
        this._funcAuthAttendance.showLeave = listMenu["att-leave"];
        this._funcAuthAttendance.showShift = listMenu["att-shift"];
        this._funcAuthAttendance.showOvt = listMenu["att-overtime"];
        this._funcAuthAttendance.showAL = listMenu["att-list"];
        this._funcAuthAttendance.showATTV = listMenu["att-validation"];
        this._funcAuthAttendance.showOffline = listMenu["att-offline"];
        this._funcAuthAttendance.showBarcode = listMenu["att-barcode"];
        this._funcAuthAttendance.showBST = listMenu["bst-request"];
        this._funcAuthAttendance.showMassLeave = listMenu["mass-leave"];
        this._funcAuthAttendance.showHelp = listMenu["att-help"];
        this._funcAuthAttendance.showABP = listMenu["att-base-photo"];
      }
    } catch (error) {
      this._funcAuthAttendance.showAE = false;
      this._funcAuthAttendance.showAC = false;
      this._funcAuthAttendance.showLeave = false;
      this._funcAuthAttendance.showShift = false;
      this._funcAuthAttendance.showOvt = false;
      this._funcAuthAttendance.showAL = false;
      this._funcAuthAttendance.showATTV = false;
      this._funcAuthAttendance.showOffline = false;
      this._funcAuthAttendance.showBarcode = false;
      this._funcAuthAttendance.showBST = false;
      this._funcAuthAttendance.showMassLeave = false;
      this._funcAuthAttendance.showHelp = false;
      this._funcAuthAttendance.showABP = false;
    }
  }

  get funcAuthAttendance() {
    return this._funcAuthAttendance;
  }

  showAttendanceLog(params: { data: any, flag: 'today' | 'yesterday', empId?: any, attendDate?: any }) {
    params.empId = this.SFGoAuth.empId;
    params.attendDate = params.flag == 'today'
      ? moment().toISOString()
      : moment().startOf('day').add(moment().utcOffset(), 'minutes').subtract(1, 'day').toISOString();

    let modal = this.modalCtrl.create("TimeAttendanceLogPage", { paramPage: params });
    modal.present();
  }

  async doRecordAttendance(): Promise<AttendanceRedirectPage> {
    this.isRunRecordTime = true;
    let result: AttendanceRedirectPage = {
      page: '',
      navType: 'push',
      params: null,
      cancelled: false,
      onDidDismiss: true
    };

    if (this.platform.is('cordova')) {
      try {
        const data = await this.recordAttendance();
        if (data) {
          if (typeof data.mockDetect != 'undefined') {
            if (data.mockDetect) {
              result.page = 'ListBlockPackagePage';
              result.params = { packages: data.value };
            } else {
              result.cancelled = true;
            }
            this.isRunRecordTime = false;
            return result;
          }
          result = await this.redirectAttPreviewPage(data);
        } else {
          result.cancelled = true;
          this.isRunRecordTime = false;
        }
      } catch (error) {
        result.cancelled = true;
        this.isRunRecordTime = false;
      }
    } else {
      let setting = await this.getAttendanceSetting();
      if (setting.takePhoto) {
        result.page = 'TimeAttendanceWebcamSfgoPage';
      } else {
        result = await this.processAttWeb(event);
      }
      result.onDidDismiss = true;
    }

    this.isRunRecordTime = false;
    return result;
  }

  async processAttWeb(event) {
    const processWebImage = await this.processWebImage(event);
    return this.redirectAttPreviewPage(processWebImage);
  }

  async redirectAttPreviewPage(data: AttendancePreviewData): Promise<AttendanceRedirectPage> {
    const result: AttendanceRedirectPage = {
      page: '',
      navType: 'push',
      params: null,
      cancelled: false,
      onDidDismiss: true
    }

    if (!data) result.cancelled = true;
    if (this.SFGoAuth.companySetting && this.SFGoAuth.companySetting.covid19Zone) {
      try {
        data.geolocation.latitude = Number(data.geolocation.latitude);
        data.geolocation.longitude = Number(data.geolocation.longitude);
        const attendanceZone = await this.covid19ZoneApi(data.geolocation);

        result.page = 'AttAlertRedZonePage';
        result.navType = 'setRoot';
        result.params = { attendanceData: data, attendanceZone: attendanceZone }
      } catch (error) {
        result.cancelled = true;
        this.isRunRecordTime = false;
        this.nestResponse.error(error);
      }
    } else {
      result.page = this.SFGoAuth.isSF6
        ? 'TimeAttendancePreviewPage'
        : 'TimeAttendancePreviewSfgoPage';

      result.params = { data: data };
    }

    return result;
  }

  get isRunRecordTime() {
    return this._isRunRecordTime;
  }

  set isRunRecordTime(value: boolean) {
    this._isRunRecordTime = value;
  }

  getShiftList(startDate: string, endDate: string): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        this.SFGoAuth = await this.appPreferences.getAuth();
        const result = await this.attendanceApi.getUserAttendanceWeekNew({
          empId: this.SFGoAuth.empId,
          startDate: startDate,
          endDate: endDate
        }).toPromise();
        resolve(result.info);
      } catch (error) {
        console.log('getShiftList', error);
        resolve([])
      }
    })
  }

  async getCameraSetting() {
    try {
      const result: any = await this.appPreferences.getGreatdayStorage<ResponseCameraSetting>(Preference.CameraSetting);
      if (result && result.attendance) {
        this.cameraSetting = result || this.cameraSetting;
      }
    } catch (error) { }
  }

  openWebcam(attNativeRecord: GDIGeolocationCamera) {
    return new Promise<GDIGeolocationCamera>(async (resolve) => {
      try {
        await this.permissionCheckProvider.getCameraPermission();
        const modal = await this.modalCtrl.create('TimeAttendanceWebcamSfgoPage');
        modal.present();

        const responseWebcam = await new Promise<ResponseWebcam>((resolve) => {
          modal.onDidDismiss((data) => resolve(data));
        });

        if (!responseWebcam) {
          attNativeRecord.cancelled = true;
        } else {
          try {
            this.SFGoAuth = await this.appPreferences.getAuth();
            const path = await this.permissionCheckProvider.getPathAttendance();
            let date = new Date().getFullYear() + new Date().getMonth() + new Date().getDate();
            let time = new Date().getTime();
            let userId = this.SFGoAuth && this.SFGoAuth.userId ? this.SFGoAuth.userId : 'not_login_yet';
            let fileName = 'img_gd_' + userId + '_' + date + '_' + time + '.jpg';

            const writeFile = await this.file.writeFile(path.nativeURL, fileName, responseWebcam.file);
            attNativeRecord.camera.nativeURL = writeFile.nativeURL;
          } catch (error) { }

          attNativeRecord.camera.base64Image = responseWebcam.base64Image;
        }
      } catch (error) {
        attNativeRecord.cancelled = true;
      } finally {
        resolve(attNativeRecord);
      }
    });
  }

  async getLanguage(): Promise<any> {
    return new Promise(async (resolve) => {
      let lang = await this.storage.get('language');
      let result = lang ? lang : "en";
      resolve(result);
    });
  }

  async getGeolocationAndroid(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        // get language
        let language = await this.getLanguage();
        let langCode = this.languageCode[language];

        // get worklocation
        let workLocation = await this.storage.get("attWorkLocation");

        // label for maps
        const label1 = this.translate.instant('Is the location of your attendance correct?');
        const label2 = this.translate.instant('GPS must have high accuracy enabled to record your attendance');

        const customPlugin = await this.greatdayPluginNative.getCustomGeolocation(label1, label2, langCode, workLocation);
        resolve(customPlugin)
      }
      catch (error) {
        console.log(error);
        resolve({ cancelled: true, camera: {}, geolocation: {} })
      }
    })
  }

  get messageFailedSendAttendance() {
    if (this.attendanceSetting && this.attendanceSetting.offlineMode) {
      return this.translate.instant(Messages.FAILED_SAVED_ATTENDANCE);
    } else {
      return this.translate.instant(Messages.FAILED_SAVED_ATTENDANCE_WITHOUT_OFFLINEMODE);
    }
  }

  getCameraFaceSpoofing() {
    return this.cameraProvider.getCameraFaceSpoofing();
  }

  getCamera() {
    if (this.attendanceSetting && this.attendanceSetting.attendanceFaceLiveness) {
      return this.getCameraFaceSpoofing();
    } else {
      return this.cameraProvider.getCamera();
    }
  }

  faceDetection(path) {
    return this.attendanceApi.faceDetection(path).map(res => res.data).toPromise();
  }

  async setBasePhoto(): Promise<void> {
    try {
      const attendanceFace = this.appPreferences.dataAuth.companySetting.attendanceFace;
      if (attendanceFace) {
        const basePhoto = await this.basePhotoApi.getBasePhoto().map(res => res.data).toPromise();
        const photo = basePhoto && basePhoto.photo ? basePhoto.photo : null;
        await this.appPreferences.setGreatdayStorage(Preference.GDAttBasePhoto, photo);
      }
    } catch (error) {
      console.log('setBasePhoto', error);
    }
  }

  async getUrlBasePhoto() {
    try {
      let result = '';
      let basePhoto = '';

      const attendanceFace = this.appPreferences.dataAuth.companySetting.attendanceFace;

      if (attendanceFace) {
        const path = await this.storagePathProvider.getStorageFaceBloc();
        const getBasePhotoStorage = await this.appPreferences.getGreatdayStorage<string>(Preference.GDAttBasePhoto);
        console.log('getBasePhotoStorage', getBasePhotoStorage);
        if (getBasePhotoStorage) {
          basePhoto = getBasePhotoStorage;
        } else {
          const getBasePhoto = await this.basePhotoApi.getBasePhoto().map(res => res.data).toPromise();
          console.log('basePhoto', getBasePhoto);
          basePhoto = getBasePhoto && getBasePhoto.photo ? getBasePhoto.photo : null;
          await this.appPreferences.setGreatdayStorage(Preference.GDAttBasePhoto, basePhoto);
        }

        if (basePhoto) {
          result = `${path.urlDownload + basePhoto}`;
        }
      }

      return result;
    } catch (error) {
      throw error;
    }
  }

  getAddress(lat: any, lng: any) {
    return new Promise<string>((resolve) => {
      let result = '';
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (response, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (response[1]) {
            result = response[1].formatted_address;
          }
        }

        resolve(result);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/attendance/attendance.bloc.ts